// Shared display formatting. Resource prices are exact game values — group them, never
// round them (the 4-significant-digit rounding for derived stats lives in stat-cell.ts).
export const exactNumber = new Intl.NumberFormat("en-US").format;

/** A game label shipped in capitals ("CIVILIAN") in the site's case convention
 * ("Civilian" — the Class labels' Title Case), word by word. Only ever applied to a label
 * the game shouts; a mixed-case label is left alone by never being passed here. */
export function titleCase(shouted: string): string {
  return shouted
    .toLowerCase()
    .replace(
      /(^|\s)(\p{L})/gu,
      (_, before: string, letter: string) => before + letter.toUpperCase(),
    );
}

/** A resource price as prose parts, zero components omitted — the one place the
 * "N credits, N metal, N crystal" wording rule lives. */
export function priceParts(price: { credits: number; metal: number; crystal: number }): string[] {
  const parts: string[] = [];
  if (price.credits > 0) parts.push(`${exactNumber(price.credits)} credits`);
  if (price.metal > 0) parts.push(`${exactNumber(price.metal)} metal`);
  if (price.crystal > 0) parts.push(`${exactNumber(price.crystal)} crystal`);
  return parts;
}
